module.exports = __webpack_public_path__ + "static/media/setting.2227c67a.svg";